module.exports = "<app-list-display [title]=\"'Teaching'\" [component_id]=\"'teaching'\" [items]=\"projects\"></app-list-display>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/spina-me/source/src/app/teaching/teaching.component.html
// module id = ../../../../../src/app/teaching/teaching.component.html
// module chunks = 1